import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Route, Switch } from "react-router";
import MSCContextWrapper from "../../contexts/MSCContext";
import { appendPath } from "@my-dld/utils/PathUtils";
import MollakServiceCharges from "./MollakServiceCharges";
import MollakServiceChargeDetails from "./MollakServiceChargeDetails";
import MollakServiceChargeSuccess from "./MollakServiceChargeSuccess";

class MollakServiceCharge extends Component<RoutedViewProps> {
	render() {
		const pp = this.props.match.url;
		return <MSCContextWrapper>
			<Switch>
				<Route
					path={ pp } exact={ true }
					component={ MollakServiceCharges }/>
				<Route
					path={ appendPath( pp, "/:propertyTypeId/:propertyId" ) }
					exact={ true } component={ MollakServiceChargeDetails }/>
				<Route
					path={ appendPath( pp, "/success/:propertyTypeId/:propertyId/:reference" ) }
					component={ MollakServiceChargeSuccess }/>
			</Switch>
		</MSCContextWrapper>;
	}
}

export default MollakServiceCharge;
